<template>
    <div>
        <EmptyListStub v-if="!orders.length && loaded" title="Список заявок пуст" classes=" mt-4" iconName="f7:rectangle-stack" />
        <!-- <transition-group class="grid" name="orders" tag="div"> -->
        <div class="grid  gap-4  grid-cols-1 md:grid-cols-2 ">
            <item-order classes="" v-for="item in orders" :key="item._id" :order="item" @click.native.stop="e => clickItem(item)"></item-order>
        </div>
        <!-- </transition-group> -->
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import itemOrder from "../../components/item/order.vue";
import OrderService from "../../services/OrderService";

import EmptyListStub from "../../components/EmptyListStub.vue";

export default {
    data() {
        return {
            orders: [],
            loaded: false
        };
    },
    components: {
        itemOrder,
        EmptyListStub
    },
    mounted() {
        this.fetchOrders();
        this.sockets.subscribe("update order", order => {
            this.orders = this.orders.map(item => {
                if (item._id === order._id) {
                    return Object.assign({}, item, order);
                } else {
                    return item;
                }
            });
        });
        this.sockets.subscribe("add order", order => {
            this.orders = [order, ...this.orders];
        });
    },
    beforeDestroy() {
        this.orders = [];
        this.sockets.unsubscribe("add order");
        this.sockets.unsubscribe("update order");
    },

    methods: {
        ...mapMutations(["SET_CURRENT_ORDER", "SET_LOADING"]),
        clickItem(i) {
            let { href } = this.$router.resolve("/order/" + i.hash);
            window.open(href, "_blank");
        },
        async fetchOrders() {
            try {
                this.SET_LOADING(true);
                let response = await OrderService.getAll();

                this.orders = response.data;
                this.loaded = true;
            } catch (e) {
                console.error(e);
            } finally {
                this.SET_LOADING(false);
            }
        }
    }
};
</script>
